import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';
import IconButton from '../IconButton/IconButton.js';
import SummaryContainer from './SummaryContainer.js';

const Summary = ({ children , onEditClick , onDeleteClick , 'data-t': dataT = 'summary' , className , editRef , 'aria-label': ariaLabel = '' ,  })=>{
    const { getLabel  } = useIntl();
    const withButtons = !!(onEditClick || onDeleteClick);
    return /*#__PURE__*/ React.createElement(SummaryContainer, {
        className: classnames('summary', className),
        "data-t": dataT
    }, withButtons && /*#__PURE__*/ React.createElement("div", {
        className: "summary__buttons"
    }, onEditClick && /*#__PURE__*/ React.createElement(IconButton, {
        className: "summary__button",
        "data-t": `${dataT}-edit-button`,
        onClick: onEditClick,
        ref: editRef,
        "aria-label": `${getLabel('common.actions.edit')} ${ariaLabel}`
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "pencil",
        className: "summary__button-icon"
    })), onDeleteClick && /*#__PURE__*/ React.createElement(IconButton, {
        className: "summary__button",
        "data-t": `${dataT}-delete-button`,
        onClick: onDeleteClick,
        "aria-label": `${getLabel('common.actions.delete')} ${ariaLabel}`
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "trash",
        className: "summary__button-icon"
    }))), children);
};

export { Summary, Summary as default };
//# sourceMappingURL=Summary.js.map
